import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchCreateEditProcedure, fetchGetPriorityDocTypes } from 'api/priority';
import { dispatch } from 'store';
import { PriorityDocType } from 'types/company-platforms/priority';

const initialState: {
  docTypes: Array<PriorityDocType>;
} = {
  docTypes: [],
};

const prioritySlice = createSlice({
  name: 'priority',
  initialState,
  reducers: {
    storeSetDocTypes: (state, action: PayloadAction<Array<PriorityDocType>>) => {
      state.docTypes = action.payload;
    },
  },
});
export default prioritySlice.reducer;

export const { storeSetDocTypes } = prioritySlice.actions;

export const setPriorityDocTypes = (docTypes: Array<PriorityDocType>) => {
  const sortedDocTypes = docTypes.sort((a, b) => a.order - b.order);
  dispatch(storeSetDocTypes(sortedDocTypes));
};
export const getPriorityDocTypes = async () => {
  try {
    const data = await fetchGetPriorityDocTypes();
    if (data) setPriorityDocTypes(data);
  } catch (error) {
    console.warn('Error in getDocTypes:', error);
  }
};
export const createEditProcedure = async (
  procedure: Omit<PriorityDocType, 'formats' | 'companyId' | 'id'>,
) => {
  try {
    const data = await fetchCreateEditProcedure(procedure);
    if (data) {
      const docTypes = await fetchGetPriorityDocTypes();
      if (docTypes) {
        setPriorityDocTypes(docTypes);
      }
    }
    return data;
  } catch (error) {
    console.warn('Error in createEditProcedure:', error);
    return null;
  }
};
